<template>
  <validation-observer
    ref="articleSaveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="articleSaveModal"
      body-class="position-static"
      centered
      size="lg"
      :title="isCreated ? 'Thêm bài báo khoa học' : 'Cập nhật bài báo khoa học'"
      :no-close-on-backdrop="true"
      @show="onShow"
      @hide="onHide"
    >
      <b-form>
        <b-row>
          <b-col cols="12">
            <b-form-group label-for="name">
              <template v-slot:label>
                Tên bài báo <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Tên bài báo"
                rules="required"
              >
                <b-form-input
                  id="name"
                  v-model="targetArticle.name"
                  name="name"
                  placeholder="Nhập tên bài báo"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-form-group
              label="Thuộc nghiên cứu khoa học"
              label-for="researchId"
            >
              <v-select
                id="researchId"
                v-model="targetArticle.researchId"
                label="name"
                :options="researches"
                :reduce="option => option.id"
                :disabled="!!researchId"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <b-form-group
              label="Số lượng tác giả"
              label-for="numberOfAuthors"
            >
              <b-form-input
                id="numberOfAuthors"
                v-model="targetArticle.numberOfAuthors"
                name="numberOfAuthors"
                placeholder="Nhập số lượng tác giả"
              />
            </b-form-group>
          </b-col>

          <b-col
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <b-form-group
              label="Số lượt trích dẫn"
              label-for="citationCount"
            >
              <b-form-input
                id="citationCount"
                v-model="targetArticle.citationCount"
                name="citationCount"
                placeholder="Nhập số lượt trích dẫn"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <b-form-group
              label="Tạp chí"
              label-for="magazineName"
            >
              <b-form-input
                id="magazineName"
                v-model="targetArticle.magazineName"
                name="magazineName"
                placeholder="Nhập tạp chí"
              />
            </b-form-group>
          </b-col>

          <b-col
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <b-form-group
              label="Tạp chí quốc tế"
              label-for="internationalMagazine"
            >
              <b-form-input
                id="internationalMagazine"
                v-model="targetArticle.internationalMagazine"
                name="internationalMagazine"
                placeholder="Nhập tạp chí quốc tế"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            sm="12"
            md="4"
            lg="4"
            xl="4"
          >
            <b-form-group
              label="Tập số"
              label-for="volume"
            >
              <b-form-input
                id="volume"
                v-model="targetArticle.volume"
                name="volume"
                placeholder="Nhập tập số"
              />
            </b-form-group>
          </b-col>

          <b-col
            sm="12"
            md="4"
            lg="4"
            xl="4"
          >
            <b-form-group
              label="Số trang"
              label-for="page"
            >
              <b-form-input
                id="page"
                v-model="targetArticle.page"
                name="page"
                placeholder="Nhập số trang"
              />
            </b-form-group>
          </b-col>

          <b-col
            sm="12"
            md="4"
            lg="4"
            xl="4"
          >
            <b-form-group
              label="Ngày phát hành"
              label-for="publishDate"
            >
              <b-input-group class="input-group-merge">
                <b-form-datepicker
                  id="startDate"
                  v-model="targetArticle.publishDate"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  locale="vi"
                  format="dd/mm/yyyy"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="clearPublishDate"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-form-group
              label="Đường dẫn bài báo"
              label-for="posts"
            >
              <b-form-input
                id="posts"
                v-model="targetArticle.posts"
                name="posts"
                placeholder="Nhập đường dẫn"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-form-group
              label="Tóm tắt"
              label-for="summary"
            >
              <ckeditor
                ref="ckRef"
                v-model="targetArticle.summary"
                :config="editorConfig"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-show="isCreated"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu và tiếp tục
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('articleSaveModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        no-wrap
        :show="isLoading"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BModal, BOverlay, BButton, BRow, BCol, BInputGroup, BInputGroupAppend, BFormDatepicker,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import { mapActions, mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'
import { getUser } from '@/auth/utils'
import vSelect from 'vue-select'
import { showErrorToast, showSuccessToast } from '@/utils/notification'

export default {
  name: 'ResearchArticleSave',
  components: {
    BFormDatepicker,
    vSelect,
    BInputGroupAppend,
    BInputGroup,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BOverlay,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    article: {
      type: Object,
      default: undefined,
    },
    researchId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      targetArticle: {
        organizationId: null,
        name: '',
        researchId: null,
        numberOfAuthors: null,
        magazineName: '',
        internationalMagazine: '',
        citationCount: null,
        volume: null,
        page: null,
        summary: '',
        publishDate: null,
        posts: '',
        status: 1,
      },
      editorConfig: {
        versionCheck: false,
      },
      required,
    }
  },
  computed: {
    ...mapGetters({
      researches: 'researchArticle/researches',
    }),
    isCreated() {
      return !this.article
    },
  },
  methods: {
    ...mapActions({
      createArticle: 'researchArticle/createResearchArticle',
      updateArticle: 'researchArticle/updateResearchArticle',
      getAllResearchesByOrganization: 'researchArticle/getAllResearchesByOrganization',
    }),
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    async onShow() {
      if (this.article) {
        this.targetArticle = { ...this.article }
      } else {
        this.targetArticle = { ...this.targetArticle, organizationId: this.user.orgId }
        if (this.researchId) {
          this.targetArticle = { ...this.targetArticle, researchId: this.researchId }
        }
      }
      this.isLoading = true
      try {
        await this.getAllResearchesByOrganization({ organizationId: this.user.orgId })
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    onHide() {
      this.$refs
        .articleSaveFormRef
        .reset()
      this.targetArticle = {
        organizationId: null,
        name: '',
        researchId: null,
        numberOfAuthors: null,
        magazineName: '',
        internationalMagazine: '',
        citationCount: null,
        volume: null,
        page: null,
        summary: '',
        publishDate: null,
        posts: '',
        status: 1,
      }
      if (this.$refs.ckRef.instance) this.$refs.ckRef.instance.destroy()
    },
    async onSave(type = null) {
      const valid = this.$refs
        .articleSaveFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = this.isCreated
            ? await this.createArticle(this.targetArticle)
            : await this.updateArticle(this.targetArticle)
          if (response) {
            const { isSuccessful, message } = response
            if (isSuccessful) {
              showSuccessToast(this, message)
              if (type === 'hide') {
                this.$bvModal.hide('articleSaveModal')
              }
              this.$emit('succeed')
            } else {
              showErrorToast(this, message)
            }
          }
        } catch (e) {
          showErrorToast(this, e)
        } finally {
          this.isLoading = false
        }
      }
    },
    clearPublishDate() {
      this.targetArticle.publishDate = null
    },
  },
}
</script>
